<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat class="hkl-report-holder">
                <v-card-title class="primary white--text headline">
                    Energy Saving Targets
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs6 style="page-break-inside: avoid !important;" class="pa-5">
                        <VueSvgGauge
                                :start-angle="-90"
                                :end-angle="90"
                                :value="mainTarget.value"
                                :separator-step="5"
                                :separator-thickness="0"
                                :min="0"
                                :max="mainTarget.target"
                                :gauge-color="[ { offset: 0, color: '#F28705'},{ offset: 70, color: '#77C16B'}]"
                                :scale-interval="5"
                        >
                            <div class="inner-text2">
                                <span>
                                    Energy Saving<br/>
                                    Reduction : <strong>{{mainTarget.value}}%</strong><br/>
                                    Target : <strong>{{mainTarget.target}}%</strong>
                                </span>
                            </div>
                        </VueSvgGauge>
                    </v-flex>
                    <v-flex xs6 class="pa-3" style="page-break-inside: avoid !important;">
                        <v-textarea solo box flat auto-grow v-model="comment1"></v-textarea>
                    </v-flex>
                    <v-flex md6 xs6 style="page-break-inside: avoid !important;" class="pa-5" v-for="facilityTarget in facilityTargets">
                        <VueSvgGauge
                                :start-angle="-90"
                                :end-angle="90"
                                :value="facilityTarget.value"
                                :separator-step="5"
                                :separator-thickness="0"
                                :min="0"
                                :max="facilityTarget.target"
                                :gauge-color="[ { offset: 0, color: '#F28705'},{ offset: 70, color: '#77C16B'}]"
                                :scale-interval="5"
                        >
                            <div class="inner-text">
                                <span>
                                    <strong>{{facilityTarget.name}}</strong><br/>
                                    Reduction : <strong>{{facilityTarget.value}}%</strong><br/>
                                    Target : <strong>{{facilityTarget.target}}%</strong>
                                </span>
                            </div>
                        </VueSvgGauge>
                    </v-flex>
                </v-layout>
                    <v-card-title class="primary white--text headline">
                        Energy Saving Short Term Target
                    </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12 class="pa-3" style="page-break-inside: avoid !important;">
                        <v-textarea solo box flat auto-grow v-model="comment2"></v-textarea>
                    </v-flex>
                    <v-flex xs12  style="page-break-inside: avoid !important;" >
                        <vue-plotly disable-responsive  v-if="chart1data" :data="chart1data" :layout="chart1layout" :options="{}"/>
                        <vue-plotly v-if="chart1table" :data="chart1table" :layout="{height:340}" :options="{}"/>
                    </v-flex>
                    <v-flex xs12 class="pa-3" style="page-break-inside: avoid !important;">
                        <v-textarea solo box flat auto-grow v-model="comment3"></v-textarea>
                    </v-flex>
                    <v-flex xs12  style="page-break-inside: avoid !important;">
                        <vue-plotly disable-responsive  v-if="chart2data" :data="chart2data" :layout="chart2layout" :options="{}"/>
                        <vue-plotly v-if="chart1table" :data="chart2table" :layout="{height:300}" :options="{}"/>
                    </v-flex>
                    <v-flex xs12 class="pa-3" style="page-break-inside: avoid !important;">
                        <v-textarea solo box flat auto-grow v-model="comment4"></v-textarea>
                    </v-flex>
                    <v-flex xs12  style="page-break-inside: avoid !important;">
                        <vue-plotly disable-responsive  v-if="chart3data" :data="chart3data" :layout="chart3layout" :options="{}"/>
                        <vue-plotly v-if="chart1table" :data="chart3table" :layout="{height:400}" :options="{}"/>
                    </v-flex>
                    <v-flex xs12 class="pa-3" style="page-break-inside: avoid !important;">
                        <v-textarea solo box flat auto-grow v-model="comment5"></v-textarea>
                    </v-flex>
                    <v-flex xs12  style="page-break-inside: avoid !important;">
                        <vue-plotly disable-responsive  v-if="chart4data" :data="chart4data" :layout="chart4layout" :options="{}"/>
                    </v-flex>
                </v-layout>
                <v-layout >
                    <v-spacer></v-spacer>
                    <v-btn
                            flat
                            @click="printReport()"
                    >
                        <v-icon class="mr-2">fa-print</v-icon>
                        Print
                    </v-btn>
                </v-layout>
            </v-card>

        </v-flex>
    </v-layout>

</template>

<script>
    import VuePlotly from '@/components/VuePlotly'
    import {callAPI} from '@/helper'
    import moment from 'moment'
    import { VueSvgGauge } from 'vue-svg-gauge'

    export default {
        name: 'ExecutiveSummary',
        components: {VuePlotly,VueSvgGauge},
        computed:{

        },
        data () {
            return {
                comment1:"With the approval from our CE in Feb 2020, " +
                    "we have set a new long-term target to reduce " +
                    "carbon emissions by 55% as compared to " +
                    "baseline level in 2008, which is equivalent to " +
                    "saving 37% of energy (electricity) by 2030.\n" +
                    "In addition to the 2030 target, an interim " +
                    "target of 32.3% of energy (electricity) " +
                    "reduction by 2025 is also set to gauge our " +
                    "continuous effort and progress.\n" +
                    "The cumulative energy reduction for 2020 as " +
                    "compared to the baseline year 2008 is " +
                    "25.86%. Below is the overall performance of " +
                    "each building.",
                comment2:"We aim to reduce energy (electricity) consumption " +
                    "for buildings in Central by 2% in 2020 as " +
                    "comparing to the level in 2019.\n In February of 2020, aggregate energy consumed 5.91% less as compared to 2019, or " +
                    "equivalent to about 727,318 kWh of electricity consumption for Central Portfolio. ",
                comment3:"In February of 2020, aggregate energy consumed 5.91% less as compared to 2019, or " +
                    "equivalent to about 727,318 kWh of electricity consumption for Central Portfolio. ",
                comment4:"The performance trend of cumulative performance of buildings is shown as follows ",
                comment5:"The graphs above indicate each complex/building’s 2020 whole year (January to December) " +
                    "energy saving performance compared to the same period of 2019.\n"+
                "The graph below indicates the derivation of 2025 interim target against the 2030 target.",
                loading:true,
                mainTarget:null,
                chart1data:null,
                chart1table:null,
                chart2data:null,
                chart3data:null,
                chart4data:null,
                chart1layout:null,
                chart2layout:null,
                chart3layout:null,
                chart4layout:null,
                facilityTargets:[],



            }
        },
        mounted(){
            this.loadData()
        },
        methods:{
            printReport(){
                window.print()
            },
            loadData(){
                let me=this
                this.facilityTargets=[
                    {
                        name:"ES",
                        target:40,
                        value:38.87
                    },
                    {
                        name:"LM",
                        target:30,
                        value:16.10
                    },
                    {
                        name:"CH",
                        target:40,
                        value:30.93
                    },
                    {
                        name:"JH",
                        target:30,
                        value:22.38
                    },
                    {
                        name:"AX",
                        target:30,
                        value:20.69
                    },
                    {
                        name:"PB",
                        value:3.56,
                        target:30
                    }
                ]
                me.mainTarget={
                    value:25.86,
                    target:37,
                    subtarget:32.3
                }
                let months=[ "January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December" ];
                let monthsCut=[ "January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December" ];
                let targetSaving=new Array(12).fill(-2);
                let overallCP=[-2.6,-5.9];
                let cec2020=[5.95,11.5];
                let cec2019=[6.11,12.3,18.3,25.8,33.7,42.8,52.2,61.8,71.2,79.6,86.8,93];
                let cecJH=[-13.4,-17];
                let cecCH=[1.9,-3.6];
                let cecPB=[-0.2,-4];
                let cecAH=[-4,-5.9];
                let cecLM=[0.5,-2.6];
                let cecES=[-4,-6.8];
                let energyReduction=[32.3,37];
                let carbonReduction=[45,55];
                let redYears=[2025,2030];
                me.chart1data=[
                    {
                        x:monthsCut,
                        y:overallCP,
                        name:"Overall (Central Portfolio)",
                        type: 'bar',
                    },{
                        x:months,
                        y:targetSaving,
                        name:"Target Saving",
                        type: 'lines',
                    },

                    ]
                me.chart1table=[{
                    type: 'table',
                    header: {
                        values: ["","January", "February", "March", "April", "May", "June",
                            "July", "August", "September", "October", "November", "December"],
                        align: "center",
                        line: {width: 1, color: 'black'},
                        fill: {color: "grey"},
                        font: {family: "Arial", size: 12, color: "white"}
                    },
                    cells: {
                        values: [
                            ["Overall (Central Portfolio)","Target Saving"],
                            ["-2.6%","-2%"],
                            ["-5.9%","-2%"],
                            ["","-2%"],
                            ["","-2%"],
                            ["","-2%"],
                            ["","-2%"],
                            ["","-2%"],
                            ["","-2%"],
                            ["","-2%"],
                            ["","-2%"],
                            ["","-2%"],
                            ["","-2%"],
                        ],
                        align: "center",
                        line: {color: "black", width: 1},
                        font: {family: "Arial", size: 11, color: ["black"]}
                    }
                }]
                me.chart1layout={
                    title:"Cumulative Energy Consumption Comparison for Central Portfolio (2020 vs 2019)",
                        legend: {
                        orientation: 'h',
                            x:0.5,
                            y:-0.3,
                            xanchor:'center'
                    },
                    yaxis: {
                        title: 'Saving (%)'
                    },

                }
                me.chart2data=[
                    {
                        x:monthsCut,
                        y:cec2020,
                        name:"2020",
                        type: 'bar',
                    },{
                        x:months,
                        y:cec2019,
                        name:"2019",
                        type: 'lines',
                    },
                ]
                me.chart2table=[{
                    type: 'table',
                    header: {
                        values: ["","January", "February", "March", "April", "May", "June",
                            "July", "August", "September", "October", "November", "December"],
                        align: "center",
                        line: {width: 1, color: 'black'},
                        fill: {color: "grey"},
                        font: {family: "Arial", size: 12, color: "white"}
                    },
                    cells: {
                        values: [
                            ["2020","2019"],
                            ["5.95","6.11"],
                            ["11.5","12.3"],
                            ["","18.3"],
                            ["","25.8"],
                            ["","33.7"],
                            ["","42.8"],
                            ["","52.2"],
                            ["","61.8"],
                            ["","71.2"],
                            ["","79.6"],
                            ["","86.8"],
                            ["","93.0"],
                        ],
                        align: "center",
                        line: {color: "black", width: 1},
                        font: {family: "Arial", size: 11, color: ["black"]}
                    }
                }]
                me.chart2layout={
                    title:"Cumulative Energy Consumption for Central Portfolio",
                    legend: {
                        orientation: 'h',
                        x:0.5,
                        y:-0.3,
                        xanchor:'center'
                    },
                    yaxis: {
                        title: '(kWh)'
                    },

                }
                me.chart3data=[
                    {
                        x:monthsCut,
                        y:cecJH,
                        name:"JH",
                        type: 'lines',
                    },{
                        x:monthsCut,
                        y:cecCH,
                        name:"CH",
                        type: 'lines',
                    },{
                        x:monthsCut,
                        y:cecPB,
                        name:"PB",
                        type: 'lines',
                    },{
                        x:monthsCut,
                        y:cecAH,
                        name:"AH",
                        type: 'lines',
                    },{
                        x:monthsCut,
                        y:cecLM,
                        name:"LM",
                        type: 'lines',
                    },{
                        x:monthsCut,
                        y:cecES,
                        name:"ES",
                        type: 'lines',
                    },
                    {
                        x:months,
                        y:targetSaving,
                        name:"Target Saving",
                        type: 'lines',
                    },
                ]
                me.chart3table=[{
                    type: 'table',
                    header: {
                        values: ["","January", "February", "March", "April", "May", "June",
                            "July", "August", "September", "October", "November", "December"],
                        align: "center",
                        line: {width: 1, color: 'black'},
                        fill: {color: "grey"},
                        font: {family: "Arial", size: 12, color: "white"}
                    },
                    cells: {
                        values: [
                            ["JH","CH","PB","AH","LM","ES","Target Saving"],
                            ["-13.4%","1.9%","-0.2%","-4.0%","0.5%","-4.0%","-2%"],
                            ["-17.0%","-3.6%","-4.0%","-5.9%","-2.6%","-6.8%","-2%"],
                            ["","","","","","","-2%"],
                            ["","","","","","","-2%"],
                            ["","","","","","","-2%"],
                            ["","","","","","","-2%"],
                            ["","","","","","","-2%"],
                            ["","","","","","","-2%"],
                            ["","","","","","","-2%"],
                            ["","","","","","","-2%"],
                            ["","","","","","","-2%"],
                            ["","","","","","","-2%"],
                        ],
                        align: "center",
                        line: {color: "black", width: 1},
                        font: {family: "Arial", size: 11, color: ["black"]}
                    }
                }]
                me.chart3layout={
                    title:"Cumulative Energy Consumption Comparison" +
                        " for Individual Building/ Complex (2020 vs 2019)",
                    legend: {
                        orientation: 'h',
                        x:0.5,
                        y:-0.3,
                        xanchor:'center'
                    },
                    yaxis: {
                        title: 'Saving (%)',
                    },
                    xaxis: {
                        showgrid:false,
                    },
                }
                me.chart4data=[
                    {
                        x:redYears,
                        y:energyReduction,
                        name:"Energy Reduction",
                        type: 'lines',
                    },{
                        x:redYears,
                        y:carbonReduction,
                        name:"Carbon Reduction",
                        type: 'lines',
                    },
                ]
                me.chart4layout={
                    title:"2020-2030 Carbon vs. Energy Percentage Reduction",
                    legend: {
                        orientation: 'h',
                        x:0.5,
                        y:-0.3,
                        xanchor:'center'
                    },
                    yaxis: {
                        title: '(%)'
                    },
                }
                setTimeout(function(){
                    me.loading=false
                },400)

            }
        }



    }
</script>

<style scoped>
    .inner-text{
        margin-right: auto;
        margin-top: 55px;
        font-size: 8px;
        width: 100px;
        text-align: center;
        margin-left: auto;
    }
    .inner-text2{
        margin-right: auto;
        margin-top: 55px;
        font-size: 8px;
        width: 100px;
        text-align: center;
        margin-left: auto;
    }
    @media not print {
        .hkl-report-holder{
            width: 900px;
            margin-left: auto;
            margin-right: auto;
        }
    }
</style>
